import { Tooltip } from '@nextui-org/react';

// Aviso accionable de formatos sin mapear (NO ENCONTRADO): píldora amarilla
// que abre el mapeo de formatos. Se usa igual en Despachos, el Gestor de
// Arribos y la cuadratura de liquidaciones. Ver design.md › Patrones repetidos.
const MapFormatsButton = ({
  onPress,
  isDisabled = false,
  label = 'Mapear formatos',
  tooltip = 'Abrir mapeo de formatos',
}: {
  onPress: () => void;
  isDisabled?: boolean;
  label?: string;
  tooltip?: string;
}) => (
  <Tooltip content={tooltip} isDisabled={isDisabled}>
    <button
      type='button'
      onClick={onPress}
      disabled={isDisabled}
      aria-label={tooltip}
      className='shrink-0 rounded-full bg-warning/15 px-2.5 py-1 text-xs font-semibold text-warning-700 transition-colors hover:bg-warning/25 disabled:cursor-not-allowed disabled:opacity-50 dark:text-warning'
    >
      {label}
    </button>
  </Tooltip>
);

export default MapFormatsButton;
